import { ShieldCheck, Truck, Wrench, Clock, MapPin, Banknote } from "lucide-react";

const items = [
  { icon: Wrench, title: "Well-Maintained Gear", text: "Every machine is serviced, fuelled and safety-checked before it leaves the yard." },
  { icon: Truck, title: "Site Delivery", text: "Free delivery for local jobs around Warragamba, Wallacia and Silverdale." },
  { icon: ShieldCheck, title: "Fully Insured", text: "Public liability cover and proper documentation supplied with every hire." },
  { icon: Clock, title: "Flexible Hire", text: "Daily, weekly or monthly. Wet or dry hire — whatever suits your project." },
  { icon: MapPin, title: "Local Operator", text: "Owner-run from Warragamba. We know the area, the soils and the access." },
  { icon: Banknote, title: "Fair Rates", text: "Transparent pricing with no hidden surprises. Quotes back fast." },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-16 md:py-24 bg-secondary text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-[0.04] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-orange-400 font-heading uppercase tracking-[0.2em] text-xs mb-4">
            <span className="w-8 h-px bg-orange-400" /> Why MRL
          </div>
          <h2 className="font-heading uppercase text-3xl md:text-5xl font-bold tracking-tight leading-tight">
            Built on a simple rule:
            <br />
            <span className="text-orange-400">do the job properly.</span>
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`why-item-${i}`}
              className="bg-secondary p-8 hover:bg-secondary/80 transition-colors"
            >
              <it.icon className="w-7 h-7 text-orange-400 mb-4" />
              <h3 className="font-heading uppercase text-lg tracking-tight">{it.title}</h3>
              <p className="text-sm text-white/70 mt-2 leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
